import React, { FC } from 'react'
import classNames from 'classnames'
import { CheckIcon } from '@heroicons/react/outline'
import { ReactComponent as MostPopularSvg } from './mostPopular.svg'
import { SubscriptionType } from '../../../types/SubscriptionType'
import { StyledSubscriptionOption } from '.'

type Props = {
  subscription: SubscriptionType;
  isSelected?: boolean;
  isPopular?: boolean;
  isTrial?: boolean;
  onChange: () => void;
}

const SubscriptionOption: FC<Props> = ({
  subscription,
  isSelected,
  isPopular,
  isTrial,
  onChange
}) => {
  return (
    <StyledSubscriptionOption
      isPopular={isPopular && !subscription.salePrice}
      isSelected={isSelected}
      isTrial={isTrial}
    >
      <input
        type="radio"
        name="subscription"
        value={subscription.id}
        onChange={() => onChange()}
        checked={isSelected}
      />
      <div className={classNames('fake-radio', { 'check-anim': isSelected })}>
        {isSelected && <CheckIcon />}
      </div>
      <div className="subscription-details">
        <span className="subscription-title">
          {subscription.description}
          {subscription.salePrice && (
            <span className="subscription-discount">${subscription.price}</span>
          )}
        </span>
        {subscription.sizzle && (
          <span className="subscription-sub-title">{subscription.sizzle}</span>
        )}
      </div>
      {isPopular && !subscription.salePrice && (
        <div className="subscription-popular">
          <MostPopularSvg />
        </div>
      )}
    </StyledSubscriptionOption>
  )
}

export default SubscriptionOption
